import React from 'react';

import { Button as AntdButton } from 'antd';

import { useBaseFormContext } from 'components/BaseForm/BaseFormContext';

import { DashboardForcesOrdreFilterForm } from '../../../../types';

import './FormFooter.less';

interface FormActionProps {
  setFilter: (value: Partial<DashboardForcesOrdreFilterForm>) => void;
}

export function FormAction({ setFilter }: FormActionProps): React.ReactElement {
  const formActions = useBaseFormContext<DashboardForcesOrdreFilterForm>();

  function resetFilter() {
    formActions.setFieldsValue({
      actionsRequises: undefined,
      classement: undefined,
      dateRangeBonEnlevement: undefined,
      dateRangeMiseEnFourriere: undefined,
      dateRangeSortieDefinitive: undefined,
      fourriere: undefined,
      commune: undefined,
      motifDeSortie: undefined,
      natureMiseEnFourriere: undefined,
      statut: undefined,
      dateRangeOrdreDestruction: undefined,
      includeDossiersAnonymises: undefined,
      includeOnlyNotDetruitApresSorti: undefined,
      idUniteFOList: undefined,
      idMarque: undefined,
      idModele: undefined,
    });
  }

  return (
    <div className={'form-footer-container'}>
      <AntdButton onClick={resetFilter}>Réinitialiser</AntdButton>

      <AntdButton
        type="primary"
        onClick={() => setFilter(formActions.getFieldsValue())}
      >
        Rechercher
      </AntdButton>
    </div>
  );
}

export default FormAction;
